import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = {
  key: 3,
  class: "file"
}
const _hoisted_3 = { class: "file__name" }
const _hoisted_4 = { class: "file__size" }
const _hoisted_5 = {
  key: 4,
  class: "bool"
}
const _hoisted_6 = {
  key: 2,
  class: "val"
}
const _hoisted_7 = {
  key: 5,
  class: "user"
}
const _hoisted_8 = { class: "user__details" }
const _hoisted_9 = { class: "user__name" }
const _hoisted_10 = { class: "user__firstname" }
const _hoisted_11 = { class: "user__lastname" }
const _hoisted_12 = { class: "user__jobtitle" }
const _hoisted_13 = {
  key: 6,
  class: "progress"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 7,
  class: "list-inline comma-sep"
}
const _hoisted_16 = {
  key: 8,
  class: "date"
}
const _hoisted_17 = { class: "val" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("td", {
    class: _normalizeClass({ checkbox: _ctx.dataType === 'checkbox' }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickCell(_ctx.dataType)))
  }, [
    (_ctx.dataType === 'checkbox')
      ? (_openBlock(), _createBlock(_component_Checkbox, {
          key: 0,
          active: _ctx.rowActive,
          onToggleCheckbox: _ctx.toggleCheckbox
        }, null, 8, ["active", "onToggleCheckbox"]))
      : _createCommentVNode("", true),
    (_ctx.dataType === 'tick')
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          class: "tick",
          type: "checkbox",
          checked: _ctx.data.selected
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.dataType === 'avatar')
      ? (_openBlock(), _createBlock(_component_Avatar, {
          key: 2,
          size: "sm",
          image: _ctx.data.image ? _ctx.data.image : null,
          alt: _ctx.data.alt ? _ctx.data.alt : null,
          text: _ctx.data.avatarText ? _ctx.data.avatarText : null
        }, null, 8, ["image", "alt", "text"]))
      : _createCommentVNode("", true),
    (_ctx.dataType === 'file')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.data.fileName), 1),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data.fileSize), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.dataType === 'boolean')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.data.value === 'true')
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                class: "val true",
                icon: "check"
              }))
            : (_ctx.data.value === 'false')
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  class: "val false",
                  icon: "times"
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "N/A"))
        ]))
      : _createCommentVNode("", true),
    (_ctx.dataType === 'user')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.data.firstName), 1),
              _cache[2] || (_cache[2] = _createTextVNode("  ", -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.data.lastName), 1)
            ]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.data.jobTitle), 1)
          ])
        ]))
      : (_ctx.dataType === 'progress')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.data.progress >= 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(_ctx.classProgress(_ctx.data.progress))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.data.progress) + "% ", 1),
                  _createVNode(_component_TranslatedText, { path: "progress.complete" })
                ], 2))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _createVNode(_component_TranslatedText, { path: "common.na" })
                ]))
          ]))
        : (_ctx.dataType === 'list')
          ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (d) => {
                return (_openBlock(), _createElementBlock("li", { key: d }, [
                  _createVNode(_component_Tooltip, {
                    text: d,
                    tooltip: _ctx.getTooltip(_ctx.dataInfo)
                  }, null, 8, ["text", "tooltip"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
    (_ctx.dataType === 'date')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatDate(_ctx.data.value)), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}